/** @jsxImportSource @emotion/react */
'use memo'

import React from 'react'
import css from '@emotion/css/macro'
import { Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import appColors from '@sportninja/common/constants/appColors'
import Text from '../../../../components/ts-components/Text'
import VideoPlayer from '../../../../components/HighlightsV2/player/VideoPlayer'
import { PlayerHighlight } from '../../../Player/types'

const colors = appColors as Record<string, string>

const modalStyles = {
  header: {
    backgroundColor: colors.SECONDARY_300,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  body: {
    borderTop: `1px solid ${colors.SOFT_STEEL}`,
    backgroundColor: colors.SECONDARY_300,
  },
  content: {
    backgroundColor: colors.SECONDARY_300,
    paddingTop: '8px',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0',
  },
}

interface Props {
  highlight: PlayerHighlight | null
  onClose: () => void
}

const HighlightVideoModal: React.FC<Props> = ({ highlight, onClose }) => {
  return (
    <Modal
      open={Boolean(highlight)}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
      centered
      title={
        <div
          css={css`
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          `}
        >
          <Text variant='heading3' weight='semiBold' color={colors.WHITE}>
            {highlight?.title || ''}
          </Text>
        </div>
      }
      closeIcon={
        <CloseOutlined
          css={css`
            color: ${colors.SOLITUDE};
            font-size: 16px;
          `}
        />
      }
      styles={modalStyles}
    >
      <VideoPlayer url={highlight?.video_url} />
    </Modal>
  )
}

export default HighlightVideoModal
